export default __webpack_public_path__ + "static/media/KOD0087-min.08c910d1.webp";